export const LOGO_DEFENSORIA_SRC = '/img/logo_branco.png';

/** Chave do token do candidato no localStorage (fluxo público do candidato). */
export const CANDIDATO_TOKEN_KEY = 'candidato_token';

/** Chave do token padrão/admin no localStorage (fallback em algumas rotas). */
export const DEFENSOR_TOKEN_KEY = '@defensor-token';

/** Domínio padrão do e-mail institucional de estagiários. */
export const EMAIL_INSTITUCIONAL_DOMINIO = '@defensoria.se.gov.br';

/** Header enviado nas rotas públicas de inscrição (ownership). */
export const CANDIDATO_ACCESS_TOKEN_HEADER = 'X-Candidato-Access-Token';

export function inscricaoRascunhoStorageKey(processoSeletivoId: number): string {
  return `inscricao-rascunho-${processoSeletivoId}`;
}

export function inscricaoAccessTokenStorageKey(candidatoId: number): string {
  return `candidato-access-token-${candidatoId}`;
}

export function saveCandidatoAccessToken(candidatoId: number, accessToken: string): void {
  if (!candidatoId || !accessToken) return;
  sessionStorage.setItem(inscricaoAccessTokenStorageKey(candidatoId), accessToken);
}

export function getCandidatoAccessToken(candidatoId: number): string | null {
  if (!candidatoId) return null;
  return sessionStorage.getItem(inscricaoAccessTokenStorageKey(candidatoId));
}

export function clearCandidatoAccessToken(candidatoId: number): void {
  if (!candidatoId) return;
  sessionStorage.removeItem(inscricaoAccessTokenStorageKey(candidatoId));
}

/** Indica se há credencial para chamar rotas públicas da inscrição. */
export function hasCandidatoPublicCredential(candidatoId?: number | null): boolean {
  if (candidatoId && getCandidatoAccessToken(candidatoId)) {
    return true;
  }
  return Boolean(
    localStorage.getItem(CANDIDATO_TOKEN_KEY) || localStorage.getItem(DEFENSOR_TOKEN_KEY),
  );
}

/** Headers para rotas públicas de candidato (token de inscrição e/ou Bearer do portal). */
export function buildCandidatoPublicHeaders(candidatoId?: number | null): Record<string, string> {
  const headers: Record<string, string> = {};
  if (candidatoId) {
    const accessToken = getCandidatoAccessToken(candidatoId);
    if (accessToken) {
      headers[CANDIDATO_ACCESS_TOKEN_HEADER] = accessToken;
    }
  }
  const bearer =
    localStorage.getItem(CANDIDATO_TOKEN_KEY) || localStorage.getItem(DEFENSOR_TOKEN_KEY);
  if (bearer) {
    headers.Authorization = `Bearer ${bearer}`;
  }
  return headers;
}

